module.exports = "<select class=form-control ng-disabled=ngDisabled ng-model=ngModel ng-transclude=optionSlot></select> ";